/**
 * Created by henian.xu on 2018/8/6.
 *
 */

export { default as TencentMap } from './tencentMap/index.vue';
